import { wrapPageElement as wrapPage } from "./src/page-wrapper";
export const wrapPageElement = wrapPage;
